<template>
  <div>
    <mds-fieldset
      :legend="translate('frequency.modal.daily.label')"
      class="frequency-modal__daily-fieldset"
      variation="radio-group"
    >
      <div class="frequency-modal__radiobuttons">
        <mds-radio-button
          v-model="selectedRadio"
          class="frequency-modal__radiobutton"
          value="Calendar"
          checked
          @input="emitDateType"
        >
          {{ translate('frequency.modal.everyday.text') }}
        </mds-radio-button>
        <mds-radio-button
          v-model="selectedRadio"
          class="frequency-modal__radiobutton"
          value="Business"
          @input="emitDateType"
        >
          {{ translate('frequency.modal.weekday.text') }}
        </mds-radio-button>
        <mds-radio-button
          v-model="selectedRadio"
          class="frequency-modal__radiobutton"
          value="Holiday"
          @input="emitDateType"
        >
          {{ translate('frequency.modal.holidays.text') }}
          <span>(excl. holidays)</span>
        </mds-radio-button>
      </div>
    </mds-fieldset>
    <holidays-field
      class="frequency-modal__holidays"
      v-if="selectedRadio === 'Holiday'"
      :selected-data="selectedData"
      @selectedCountry="assignCountry"
      v-on="$listeners"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import MdsFieldset from '@mds/fieldset'
import MdsRadioButton from '@mds/radio-button'
import HolidaysField from '@/components/frequencyModal/frequencies/helpers/HolidaysField.vue'
import MwcBaseHelpersMixin from '@morningstar/mcl-utilities/src/vue/mixins/mwc-base-mixin'
import defaultConfig from '@/components/frequencyModal/config/i18n'
import {
  DAY_TYPES,
  FREQUENCIES,
} from '@/components/frequencyModal/config/constants'

export default {
  name: 'DailyFrequency',
  components: {
    MdsFieldset,
    MdsRadioButton,
    HolidaysField,
  },
  props: {
    dateType: {
      type: String,
      default: '',
    },
  },
  mixins: [MwcBaseHelpersMixin],
  data() {
    return {
      defaultConfig,
      selectedRadio: '',
      selectedCountry: '',
    }
  },
  watch: {
    selectedCountry() {
      this.emitDateType()
    },
  },
  created() {
    const businessType = this.dateType.includes('-Business')
      ? 'Holiday'
      : this.dateType
    this.selectedRadio =
      this.editedSchedule?.frequency?.repeatType !== FREQUENCIES.Daily
        ? Object.keys(DAY_TYPES)[0]
        : businessType
    this.selectedCountry = this.dateType.includes('-Business')
      ? this.dateType.split('-')[0]
      : this.selectedCountry
    this.emitDateType()
  },
  computed: {
    ...mapState({
      editedSchedule: (state) => state.cache.cache.editedSchedule,
    }),
    compositeDateType() {
      return this.selectedRadio === 'Holiday'
        ? `${this.selectedCountry}-Business`
        : this.selectedRadio
    },
    selectedData() {
      if (this.editedSchedule?.frequency?.repeatType === 'Daily') {
        return this.dateType
      }
      return ''
    },
  },
  methods: {
    emitDateType() {
      this.$emit('input', { dateType: this.compositeDateType })
    },
    assignCountry(event) {
      this.selectedCountry = event
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@mds/constants';
@import '@mds/typography';
.frequency-modal {
  &__daily-fieldset {
    &::v-deep [class^='mds-fieldset__legend'] {
      margin-bottom: $mds-space-1-x;
    }
    display: flex;
    flex-direction: row;
  }
  &__radiobuttons {
    display: flex;
    justify-content: space-between;
    flex: auto;
  }
  &__radiobutton {
    max-width: 110px;
    &::v-deep [class^='mds-radio-button__text'] {
      @include mds-body-text-s();
    }
    span {
      color: $mds-text-color-secondary;
    }
  }
  &__holidays {
    background-color: $mds-feedback-color-info;
    margin-top: $mds-space-2-x;
    padding: $mds-space-1-and-a-half-x;
  }
}
</style>
